<template>
  <span>{{ formattedValue }}</span>
</template>

<script setup lang="ts">
import { setCommaWithDigits } from "~/utils/numberFormat";

const props = withDefaults(
  defineProps<{
    value: number;
    duration?: number;
    decimals?: number;
  }>(),
  {
    duration: 1000,
    decimals: 2,
  }
);

const displayValue = ref(0);
const animationFrame = ref<number | null>(null);

const formattedValue = computed(() => {
  return setCommaWithDigits(displayValue.value, props.decimals);
});

// 애니메이션 함수
const animateValue = (start: number, end: number, duration: number) => {
  if (animationFrame.value) {
    cancelAnimationFrame(animationFrame.value);
  }

  const startTime = performance.now();
  const diff = end - start;

  const step = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // easeOutExpo 이징 함수
    const easeProgress =
      progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

    displayValue.value = start + diff * easeProgress;

    if (progress < 1) {
      animationFrame.value = requestAnimationFrame(step);
    } else {
      displayValue.value = end;
    }
  };

  animationFrame.value = requestAnimationFrame(step);
};

// value 변경 감지
watch(
  () => props.value,
  (newValue, oldValue) => {
    animateValue(oldValue || 0, newValue, props.duration);
  },
  { immediate: true }
);

// 컴포넌트 언마운트 시 애니메이션 정리
onUnmounted(() => {
  if (animationFrame.value) {
    cancelAnimationFrame(animationFrame.value);
  }
});
</script>
